import ls07 from 'Images/legend/ls07.png';
import ls11b from 'Images/legend/ls11b.png';
import ps01 from 'Images/legend/ps01.png';
import ps05_10 from 'Images/legend/ps05_10.png';
import ps07green from 'Images/legend/ps07green.png';
import ps09 from 'Images/legend/ps09.png';
import ps11 from 'Images/legend/ps11.png';
import ps11a from 'Images/legend/ps11a.png';
import ps12 from 'Images/legend/ps12.png';
import ps14 from 'Images/legend/ps14.png';
import ps18 from 'Images/legend/ps18.png';
import ps21 from 'Images/legend/ps21.png';
import ps24 from 'Images/legend/ps24.png';

import {
  ls11a,
  ls24,
  ls28,
  ls31,
  ls32,
  lsi4,
  ps30,
  ps31,
  psi21,
  psi36,
  psi4,
  pspm2,
} from './legendHtmlIcons';
import {TLegendCategory} from './legendTypes';

export const PRESCRIPTION_TYPES = {
  'i21,PM1_surf': 'i21,PM1_surf',
  i36_surf: 'i36_surf',
  PM2_surf: 'PM2_surf',
  i4_surf: 'i4_surf',
  '01_surf': '01_surf',
  '07,08,25_surf': '07,08,25_surf',
  '11_surf': '11_surf',
  '11a,1504_surf': '11a,1504_surf',
  '31_surf': '31_surf',
  '05,10_surf': '05,10_surf',
  '21_surf': '21_surf',
  '24_surf': '24_surf',
  '09_surf': '09_surf',
  '30_surf': '30_surf',
  '12_surf': '12_surf',
  '14_surf': '14_surf',
  '18_surf': '18_surf',
  '31_line': '31_line',
  i4_line: 'i4_line',
  '07,07a_line': '07,07a_line',
  '11a_line': '11a_line',
  '32_line': '32_line',
  '11b_line': '11b_line',
  '24_line': '24_line',
  '28_line': '28_line',
};

export const MIN_RISK_PRESCRIPTION_LAYERS_ZOOM = 15;
export const MIN_PRESCRIPTIONS_LAYERS_ZOOM = 17;
export const MIN_ZONING_LAYER_ZOOM = 11; // set 13 or 14
// if no need for big cities zonings
export const MAX_ZONING_LAYER_ZOOM = 17;
export const MIN_PARCELS_LAYER_ZOOM = 18;

export const prescriptionCategories: TLegendCategory[] = [
  {
    title: 'Nuisances & risques',
    minZoom: MIN_RISK_PRESCRIPTION_LAYERS_ZOOM,
    elements: [
      {
        types: PRESCRIPTION_TYPES['i21,PM1_surf'],
        title: 'natural risk prevention plan area',
        icon: psi21,
        isCheckedByDefault: false,
      },
      {
        types: PRESCRIPTION_TYPES['i36_surf'],
        title: 'noise exposure plan area',
        icon: psi36,
        isCheckedByDefault: false,
      },
      {
        types: PRESCRIPTION_TYPES['PM2_surf'],
        title: 'installation classified for the protection of the environment',
        icon: pspm2,
        isCheckedByDefault: false,
      },
      {
        types: PRESCRIPTION_TYPES['i4_surf'],
        title: 'high voltage lines',
        icon: psi4,
        isCheckedByDefault: false,
      },
      {
        types: PRESCRIPTION_TYPES['i4_line'],
        title: 'high voltage lines',
        icon: lsi4,
        isCheckedByDefault: false,
      },
    ],
  },
  {
    title: 'Eléments protégés et patrimoniaux',
    minZoom: MIN_PRESCRIPTIONS_LAYERS_ZOOM,
    elements: [
      {
        types: PRESCRIPTION_TYPES['01_surf'],
        title: 'classified wooded area',
        icon: ps01,
        isCheckedByDefault: true,
      },
      {
        types: PRESCRIPTION_TYPES['07,08,25_surf'],
        title:
          'landscape elements (buildings and spaces), heritage, viewpoint, to protect, to enhance',
        icon: ps07green,
        isCheckedByDefault: true,
      },
      {
        types: PRESCRIPTION_TYPES['07,07a_line'],
        title: 'protected heritage element (built, landscape)',
        icon: ls07,
        isCheckedByDefault: true,
      },
    ],
  },
  {
    title: 'Implantation & volume',
    minZoom: MIN_PRESCRIPTIONS_LAYERS_ZOOM,
    elements: [
      {
        types: PRESCRIPTION_TYPES['11_surf'],
        title:
          'specific restrictions on the location of constructions (constructible strip, setback, non-built up zone, alignment, footprint of constructions, etc.)',
        icon: ps11,
        isCheckedByDefault: true,
      },
      {
        types: PRESCRIPTION_TYPES['11a,1504_surf'],
        title: 'setback',
        icon: ps11a,
        isCheckedByDefault: true,
      },
      {
        types: PRESCRIPTION_TYPES['11a_line'],
        title: 'setback',
        icon: ls11a,
        isCheckedByDefault: true,
      },
      {
        types: PRESCRIPTION_TYPES['31_surf'],
        title: 'height net',
        icon: ps31,
        isCheckedByDefault: false,
      },
      {
        types: PRESCRIPTION_TYPES['31_line'],
        title: 'height net',
        icon: ls31,
        isCheckedByDefault: false,
      },
      {
        types: PRESCRIPTION_TYPES['32_line'],
        title: 'alignment easement',
        icon: ls32,
        isCheckedByDefault: true,
      },
      {
        types: PRESCRIPTION_TYPES['11b_line'],
        title: 'visual breakthrough requirement',
        icon: ls11b,
        isCheckedByDefault: true,
      },
    ],
  },
  {
    title: 'Programmation & stationnement',
    minZoom: MIN_PRESCRIPTIONS_LAYERS_ZOOM,
    elements: [
      {
        types: PRESCRIPTION_TYPES['05,10_surf'],
        title:
          'reserved space for equipment or roads that can replace the public limit',
        icon: ps05_10,
        isCheckedByDefault: true,
      },
      {
        types: PRESCRIPTION_TYPES['21_surf'],
        title: 'indicative equipment location',
        icon: ps21,
        isCheckedByDefault: true,
      },
      {
        types: PRESCRIPTION_TYPES['24_line'],
        title: 'location of path/roadway',
        icon: ls24,
        isCheckedByDefault: true,
      },
      {
        types: PRESCRIPTION_TYPES['28_line'],
        title: 'line of activities',
        icon: ls28,
        isCheckedByDefault: true,
      },
      {
        types: PRESCRIPTION_TYPES['24_surf'],
        title: 'lanes, paths, public transport to be preserved and created',
        icon: ps24,
        isCheckedByDefault: true,
      },
      {
        types: PRESCRIPTION_TYPES['09_surf'],
        title: 'reserved space housing program with social mix',
        icon: ps09,
        isCheckedByDefault: true,
      },
      {
        types: PRESCRIPTION_TYPES['30_surf'],
        title: 'area close to public transport',
        icon: ps30,
        isCheckedByDefault: false,
      },
    ],
  },
  {
    title: "Périmètre d'intention de projet",
    minZoom: MIN_PRESCRIPTIONS_LAYERS_ZOOM,
    elements: [
      {
        types: PRESCRIPTION_TYPES['12_surf'],
        title: 'area awaiting a global development project',
        icon: ps12,
        isCheckedByDefault: true,
      },
      {
        types: PRESCRIPTION_TYPES['14_surf'],
        title: 'ground plane sector',
        icon: ps14,
        isCheckedByDefault: true,
      },
      {
        types: PRESCRIPTION_TYPES['18_surf'],
        title: 'sector including OAPs',
        icon: ps18,
        isCheckedByDefault: true,
      },
    ],
  },
];
